import React from 'react';
import {Typography} from '@material-ui/core';

import styles from './FeatureCard.scss';
import Card from 'components/controls/Card';
import CustomGrid from '../../controls/grid/CustomGrid';
import CustomBox from 'components/controls/grid/CustomBox';

export default function FeatureCard(props) {
    const {title, text, Icon, className} = props;

    return (
        <Card classes={{root: className}}>
            <CustomGrid
                container
            >
                <CustomGrid
                    item
                    xs={12}
                >
                    <Icon className={styles.icon} />
                </CustomGrid>

                <CustomBox
                    my="xxl"
                    mx="xl"
                >
                    <CustomGrid
                        container
                        spacing="m"
                    >
                        <CustomGrid
                            item
                            xs={12}
                        >
                            <Typography variant="h3" color="primary">
                                {title}
                            </Typography>
                        </CustomGrid>
                        <CustomGrid
                            item
                            xs={12}
                        >
                            <Typography
                                variant="body1"
                                dangerouslySetInnerHTML={{__html: text}}
                            />
                        </CustomGrid>
                    </CustomGrid>
                </CustomBox>
            </CustomGrid>
        </Card>
    );
}



// WEBPACK FOOTER //
// ./src/components/Index/sections/FeatureCard.jsx